<template>
  <v-container>
    <cumulus-edit-dialog
      ref="editReservation"
      v-model="dialogEditReservation"
      icon="$edit"
      :max-width="700"
      :title="$t('reservation')"
      :loading="loading"
      can-delete
      persistent
      @save="saveReservation"
      @remove="removeReservation"
      @escape="closeDialogEditReservation"
    >
      <template v-slot:editform>
        <edit-reservation
          :reservation="edited_item"
        />
      </template>
    </cumulus-edit-dialog>
    <v-tabs
      v-model="activeTab"
      fixed-tabs
      background-color="blue accent-4"
      centered
      dark
      icons-and-text
      show-arrows
    >
      <v-tabs-slider />
      <v-tab
        v-for="(plane, i) in (planes)"
        :key="i"
        plane="plane"
      >
        {{ plane.reg_num }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab">
      <v-tab-item
        v-for="(plane, i) in (planes)"
        :key="i"
      />
    </v-tabs-items>

    <v-row class="fill-height">
      <v-col
        cols="12"
        md="12"
      >
        <v-sheet height="64">
          <v-toolbar
            flat
          >
            <v-btn
              outlined
              class="mr-4"
              color="grey darken-2"
              @click="setToday"
            >
              {{ $t('today') }}
            </v-btn>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="prev"
            >
              <v-icon small>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="next"
            >
              <v-icon small>
                mdi-chevron-right
              </v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-spacer />
            <v-menu
              v-if="!$vuetify.breakpoint.xs"
              bottom
              right
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  color="grey darken-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  <span>{{ $t(typeToLabel[type]) }}</span>
                  <v-icon right>
                    mdi-menu-down
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(mode, i) in (calendarModes)"
                  :key="i"
                  @click="changeCalendarView(mode)"
                >
                  <v-list-item-title>{{ $t(mode) }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <tooltip-btn
              v-shortkey.once="['f2']"
              custom-class="ml-4"
              color="primary"
              :title="$t('new_reservation')"
              dynamic
              icon="mdi-plus-circle"
              :text="false"
              :tooltip="'new_reservation'"
              @click="showDialogEditReservation()"
              @shortkey="showDialogEditReservation()"
            />
          </v-toolbar>
        </v-sheet>
        <v-sheet height="600">
          <v-calendar
            ref="calendar"
            v-model="focus"
            locale="hu"
            color="primary"
            :events="events"
            :event-color="getEventColor"
            :type="$vuetify.breakpoint.mobile ? 'day' : type"
            interval-height="27"
            interval-minutes="30"
            :interval-count="night_reservation_on ? 48 : 30"
            :weekdays="weekdays"
            :first-time="night_reservation_on ? '00:00' : '06:00'"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @change="updateRange"
            @mousedown:event="startDrag"
            @mousedown:time="startTime"
            @mousemove:time="mouseMove"
            @mouseup:time="endDrag"
            @mouseleave.native="cancelDrag"
          >
            <template v-slot:interval="{ date, time }">
              <div
                :class="{afis: afisOn(date, time)}"
              >
                &nbsp;
              </div>
            </template>
            <template
              v-slot:event="{ event, timed, eventSummary, eventParsed }"
            >
              <div v-if="eventParsed.input.name">
                <div
                  class="v-event-draggable"
                  v-html="eventParsed.input.name + ' ' + eventParsed.input.regnum"
                />
                <div
                  v-if="eventParsed.start.date == eventParsed.end.date"
                  class="v-event-draggable"
                  v-html="eventParsed.start.time + ' - ' + eventParsed.end.time"
                />
                <div
                  v-if="eventParsed.start.date !== eventParsed.end.date"
                  class="v-event-draggable"
                  v-html="eventParsed.start.date + ' ' + eventParsed.start.time + ' - ' + eventParsed.end.date + ' ' + eventParsed.end.time"
                />
                <div
                  v-if="eventParsed.input.instructor_name !== ''"
                  class="v-event-draggable"
                  v-html="$t('fields.instructor') + ': ' + eventParsed.input.instructor_name"
                />
                <div
                  v-if="timed"
                  class="v-event-drag-bottom"
                  @mousedown.stop="extendBottom(event)"
                />
              </div>
            </template>
          </v-calendar>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { call, get, sync } from 'vuex-pathify'
  import moment from 'moment'
  import EditReservation from '@/layouts/default/edit/Reservation'
  import CumulusEditDialog from '@/components/EditDialog'

  export default {
    components: {
      CumulusEditDialog,
      EditReservation,
    },
    data: () => ({
      activeTab: 0,
      // planes: [],
      focus: '',
      type: 'week',
      typeToLabel: {
        month: 'month',
        week: 'week',
        day: 'day',
        aggregated_view: 'aggregated_view',
      },
      calendarModes: ['month', 'week', 'day', 'aggregated_view'],
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
      weekdays: [1, 2, 3, 4, 5, 6, 0],
      afis: [],
      dragEvent: null,
      dragStart: null,
      createEvent: null,
      createStart: null,
      extendOriginal: null,
      edited_item: {},
      date_interval: {
        start: null,
        end: null,
      },
      dialogEditReservation: false,
    }),
    computed: {
      loading: sync('app/loading'),
      profile: get('auth/profile'),
      current_plane () { return this.planes[this.activeTab] },
      planes () { return this.profile.organization.planes.filter(p => p.rentable === 1 && p.functional === 1) },
      is_reservation_admin () { return this.profile.can['reservation-administration'] },
      night_reservation_on () { return this.profile.organization.settings.night_reservation_on },
    },
    watch: {
      activeTab: {
        handler () {
          this.updateRange(this.date_interval)
          // this.load()
        },
        deep: true,
      },
    },
    mounted () {
      this.$refs.calendar.scrollToTime('08:00')
      this.type = this.profile.settings.reservation_calendar_type
      this.changeCalendarView(this.type)
    },
    methods: {
      getReservations: call('reservations/search'),
      getAfisInfo: call('reservations/getAfisInfo'),
      Update: call('reservations/update'),
      Insert: call('reservations/insert'),
      Delete: call('reservations/delete'),
      fetchDatasource: call('datasource/fetchDatasource'),
      async updateRange ({ start, end }) {
        const events = []
        this.events = []
        this.date_interval = {
          start: start,
          end: end,
        }
        const userId = this.profile.user_id
        const isReservationAdmin = this.is_reservation_admin
        const type = this.type
        await this.getReservations({
          start: new Date(`${start.date}T00:00:00`),
          end: new Date(`${end.date}T23:59:59`),
          plane_id: this.current_plane.id,
        }).then(response => {
          // console.log(this.profile.user_id)
          response.map(function (event, key) {
            const start = moment(event.reservation_start)
            const end = moment(event.reservation_end)
            if (type !== 'month') {
              events.push({
                start: start.clone().add(-15, 'minutes').toDate(),
                end: start.toDate(),
                color: 'blue-grey lighten-5',
                timed: true,
                id: 'blank_' + start.clone().add(-15, 'minutes').format('YYMMDDHHmm'),
              })
            }
            events.push({
              id: event.id,
              name: event.pilot.name,
              instructor_name: event.instructor_id !== null ? event.instructor.name : '',
              regnum: event.plane.reg_num,
              start: start.toDate(),
              end: end.toDate(),
              color: (event.pilot_id === userId || event.instructor_id === userId || isReservationAdmin) ? 'green accent-3' : 'blue accent-3',
              timed: true,
              reservation: event,
            })
            if (type !== 'month') {
              events.push({
                start: end.toDate(),
                end: end.clone().add(+15, 'minutes').toDate(),
                color: 'blue-grey lighten-5',
                timed: true,
                id: 'blank_' + end.format('YYMMDDHHmm'),
              })
            }
          })
        }).catch(e => {
          console.log(e)
        })

        // Get AFIS Info
        await this.getAfisInfo({
          start: new Date(`${start.date}T00:00:00`),
          end: new Date(`${end.date}T23:59:59`),
        }).then(response => {
          this.afis = response
        })

        // Filter Duplicates
        const filteredEvents = events.reduce((acc, current) => {
          const x = acc.find(item => item.id === current.id)
          if (!x) {
            return acc.concat([current])
          } else {
            return acc
          }
        }, [])
        this.events = filteredEvents
      },
      getEvents ({ start, end }) {
        const events = []

        const min = new Date(`${start.date}T00:00:00`)
        const max = new Date(`${end.date}T23:59:59`)
        const days = (max.getTime() - min.getTime()) / 86400000
        const eventCount = this.rnd(days, days + 20)

        for (let i = 0; i < eventCount; i++) {
          const allDay = this.rnd(0, 3) === 0
          const firstTimestamp = this.rnd(min.getTime(), max.getTime())
          const first = new Date(firstTimestamp - (firstTimestamp % 900000))
          const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
          const second = new Date(first.getTime() + secondTimestamp)

          events.push({
            name: this.names[this.rnd(0, this.names.length - 1)],
            start: first,
            end: second,
            color: this.colors[this.rnd(0, this.colors.length - 1)],
            timed: !allDay,
          })
        }

        this.events = events
      },
      viewDay ({ date }) {
        this.focus = date
        this.type = 'day'
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.focus = ''
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      showEvent ({ nativeEvent, event }) {
        // console.log(nativeEvent.target)
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          setTimeout(() => {
            this.selectedOpen = true
          }, 10)
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          setTimeout(open, 10)
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },
      startDrag ({ event, timed }) {
        // console.log('START_DRAG')
        if (event && timed) {
          this.dragEvent = event
          this.dragTime = null
          this.extendOriginal = null
        }
      },
      startTime (tms) {
        const mouse = this.toTime(tms)
        if (this.dragEvent && this.dragTime === null) {
          const start = this.dragEvent.start
          this.dragTime = mouse - start
        } else {
          this.createStart = this.roundTime(mouse)
          this.createEvent = {
            id: -1,
            name: this.profile.user_name,
            regnum: this.current_plane.reg_num,
            color: this.rndElement(this.colors),
            start: this.createStart,
            end: this.createStart,
            timed: true,
          }
          this.events.push(this.createEvent)
        }
      },
      extendBottom (event) {
        this.createEvent = event
        this.createStart = event.start
        this.extendOriginal = event.end
      },
      mouseMove (tms) {
        const mouse = this.toTime(tms)
        if (this.dragEvent && this.dragTime !== null) {
          if (!this.dragEvent.id) {
            return
          }
          const start = this.dragEvent.start
          const end = this.dragEvent.end
          const duration = end - start
          const newStartTime = mouse - this.dragTime
          const newStart = this.roundTime(newStartTime)
          const newEnd = newStart + duration

          this.dragEvent.start = newStart
          this.dragEvent.end = newEnd
        } else if (this.createEvent && this.createStart !== null) {
          const mouseRounded = this.roundTime(mouse, false)
          const min = Math.min(mouseRounded, this.createStart)
          const max = Math.max(mouseRounded, this.createStart)

          this.createEvent.start = min
          this.createEvent.end = max
        }
      },
      endDrag () {
        this.edited_event = this.createEvent ?? this.dragEvent
        this.dragTime = null
        this.dragEvent = null
        this.createEvent = null
        this.createStart = null
        this.extendOriginal = null
        if (this.edited_event.id) {
          this.showDialogEditReservation(this.edited_event)
        }
      },
      cancelDrag () {
        if (this.createEvent) {
          if (this.extendOriginal) {
            this.createEvent.end = this.extendOriginal
          } else {
            const i = this.events.indexOf(this.createEvent)
            if (i !== -1) {
              this.events.splice(i, 1)
            }
          }
        }

        this.createEvent = null
        this.createStart = null
        this.dragTime = null
        this.dragEvent = null
      },
      roundTime (time, down = true) {
        const roundTo = 15 // minutes
        const roundDownTime = roundTo * 60 * 1000

        return down
          ? time - time % roundDownTime
          : time + (roundDownTime - (time % roundDownTime))
      },
      toTime (tms) {
        return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
      },
      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },
      rndElement (arr) {
        return arr[this.rnd(0, arr.length - 1)]
      },

      showDialogEditReservation (item) {
        // console.log('Edit')
        // console.log(item)
        // console.log('____')
        if (item) {
          if (!item.reservation) {
            this.edited_item = {
              pilot_id: this.profile.user_id,
              plane_id: this.current_plane.id,
            }
          } else {
            this.edited_item = Object.assign({}, item.reservation)
            if (this.edited_item.pilot_id !== this.profile.user_id && this.edited_item.instructor_id !== this.profile.user_id && !this.is_reservation_admin) {
              return
            }
          }
          this.edited_item.reservation_start = moment(item.start).format('YYYY-MM-DD HH:mm')
          this.edited_item.reservation_end = moment(item.end).format('YYYY-MM-DD HH:mm')
        } else {
          const start = this.roundTime(Date.now())
          this.edited_item = {
            pilot_id: this.profile.user_id,
            plane_id: this.current_plane.id,
            reservation_start: moment(start).add(30, 'minute').format('YYYY-MM-DD HH:mm'),
            reservation_end: moment(start).add(90, 'minute').format('YYYY-MM-DD HH:mm'),
          }
        }
        this.dialogEditReservation = true
      },
      closeDialogEditReservation () {
        this.dialogEditReservation = false
        this.$nextTick(() => {
          this.updateRange(this.date_interval)
          this.edited_item = {}
        })
      },
      async saveReservation () {
        this.edited_item.reservation_start = moment(this.edited_item.reservation_start).format('YYYY-MM-DD HH:mm')
        this.edited_item.reservation_end = moment(this.edited_item.reservation_end).format('YYYY-MM-DD HH:mm')
        // console.log(this.edited_item)
        if (this.edited_item.id > -1) {
          this.Update(
            this.edited_item,
          ).then(response => {
            // this.edited_item = response
            this.closeDialogEditReservation()
          }).catch(e => {
            this.$refs.editReservation.setErrors(e)
            // console.log(e)
          })
        } else {
          this.Insert(
            this.edited_item,
          ).then(response => {
            // this.edited_item = response
            this.closeDialogEditReservation()
          }).catch(e => {
            this.$refs.editReservation.setErrors(e)
            // console.log(e)
          })
        }
      },
      async removeReservation () {
        this.loading = true
        await this.Delete(
          { id: this.edited_item.id },
        ).then(response => {
          this.closeDialogEditReservation()
        }).catch(e => {
          this.loading = false
          this.$refs.editReservation.setErrors(e)
          console.log(e)
        })
      },
      afisOn (date, time) {
        var result = this.afis.filter(f => date === f.date)[0]
        if (result != null) {
          return time >= result.start && time <= result.end
        }
        return false
      },
      aggregatedView () {
        this.$router.push('/reservations-aggregated').catch(() => {})
      },
      changeCalendarView (mode) {
        if (mode === 'aggregated_view') {
          this.$router.push('/reservations-aggregated').catch(() => {})
        } else {
          this.type = mode
        }
      },
    },
  }
</script>

<style lang="sass">
.afis
 background-color: #F1F8E9
 padding: 1px

.v-tab--active
  color: #222222 !important
  background-color: #ffff !important

#calendar
  .v-calendar-weekly__day:last-child,
  .v-calendar-weekly__head-weekday:last-child
    border-right: none

  .v-calendar-weekly__week:last-child .v-calendar-weekly__day
    border-bottom: none

.v-event-draggable
  padding-left: 6px

.v-event-timed
  user-select: none
  -webkit-user-select: none

.v-event-drag-bottom
  position: absolute
  left: 0
  right: 0
  bottom: 4px
  height: 4px
  cursor: ns-resize

  &::after
    display: none
    position: absolute
    left: 50%
    height: 4px
    border-top: 1px solid #ffffff
    border-bottom: 1px solid white
    width: 16px
    margin-left: -8px
    opacity: 0.8
    content: ''

  &:hover::after
    display: block

.v-event-2
  width: 100% !important
  height: calc(100% - 44px) !important
  padding-top: 10px
.v-event-timed-container
  margin-right: 0px !important

</style>
